import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaylistStarFullColor = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M13.9697 12.9697C14.2626 12.6768 14.7374 12.6768 15.0303 12.9697L21.5303 19.4697C21.8232 19.7626 21.8232 20.2374 21.5303 20.5303C21.2374 20.8232 20.7626 20.8232 20.4697 20.5303L13.9697 14.0303C13.6768 13.7374 13.6768 13.2626 13.9697 12.9697Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 13C2 12.4477 2.44772 12 3 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H3C2.44772 14 2 13.5523 2 13ZM2 5C2 4.44772 2.44772 4 3 4H13C13.5523 4 14 4.44772 14 5C14 5.55228 13.5523 6 13 6H3C2.44772 6 2 5.55228 2 5ZM2 9C2 8.44772 2.44772 8 3 8H9C9.55228 8 10 8.44772 10 9C10 9.55228 9.55228 10 9 10H3C2.44772 10 2 9.55228 2 9Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 17C2 16.4477 2.44772 16 3 16H8C8.55228 16 9 16.4477 9 17C9 17.5523 8.55228 18 8 18H3C2.44772 18 2 17.5523 2 17Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.592 17.3135C13.4764 16.7356 13.4186 16.4466 13.3152 16.196C13.0325 15.5113 12.4887 14.9675 11.804 14.6848C11.5534 14.5814 11.2644 14.5236 10.6865 14.408C9.83025 14.2367 9.40212 14.1511 9.27436 14.0538C8.90855 13.7752 8.90855 13.2248 9.27436 12.9462C9.40212 12.8489 9.83024 12.7633 10.6865 12.592C11.2644 12.4764 11.5534 12.4186 11.804 12.3152C12.4887 12.0325 13.0325 11.4887 13.3152 10.804C13.4186 10.5534 13.4764 10.2644 13.592 9.68649C13.7633 8.83024 13.8489 8.40212 13.9462 8.27436C14.2248 7.90855 14.7752 7.90855 15.0538 8.27436C15.1511 8.40212 15.2367 8.83025 15.408 9.68649C15.5236 10.2644 15.5814 10.5534 15.6848 10.804C15.9675 11.4887 16.5113 12.0325 17.196 12.3152C17.4466 12.4186 17.7356 12.4764 18.3135 12.592C19.1698 12.7633 19.5979 12.8489 19.7256 12.9462C20.0915 13.2248 20.0915 13.7752 19.7256 14.0538C19.5979 14.1511 19.1698 14.2367 18.3135 14.408C17.7356 14.5236 17.4466 14.5814 17.196 14.6848C16.5113 14.9675 15.9675 15.5113 15.6848 16.196C15.5814 16.4466 15.5236 16.7356 15.408 17.3135C15.2367 18.1698 15.1511 18.5979 15.0538 18.7256C14.7752 19.0915 14.2248 19.0915 13.9462 18.7256C13.8489 18.5979 13.7633 18.1697 13.592 17.3135Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgPlaylistStarFullColor);
export { ForwardRef as ReactComponent };
